<template>
	<div class="bg-color-white header-column" id="header-column">



    <div class="clear block-center w1200 h94">
      <!-- logo begin -->
      <div class="fl w260 h100p pos-relative logo-box">
        <img class="max-h100p pos-abs pos-c-l l30"
             :src="publicPath + 'static/images/common/logo.png'"
             alt="logo">
      </div>
      <!-- logo end -->

      <div class="mg-l300 h100p">
        <div class="h100p pos-relative header-text">
          <img class="max-h100p pos-abs pos-c-l l60"
               :src="publicPath + 'static/images/common/top_text.png'"
               alt="logo">
        </div>

      </div>
    </div>

    <!-- menu begin -->
    <div class="text-center main-menu">
      <div class="clear inline-block pd-t12 main-menu-list">
        <div @click.stop="goToPage(item)"
             class="fl main-menu-list-item"
             :class="[{'is-active': isActive(item.routerName)}]"
             v-for="(item, index) in $store.state.mainMenu">
          <div class="main-menu-list-item-text">
            <div class="f18 h30 lh30 zh">{{ item.name[0] }}</div>
            <div class="en">
              <img :src="item.icon_img" alt="">
            </div>
          </div>

          <div class="menu-child-list-lv1" v-if="item.children && item.children.length > 0">
            <div @click.stop="goToPage(item1)" class="menu-child-list-lv1-item" v-for="(item1, index1) in item.children">

              <div class="menu-child-list-lv2-item-text">
                {{ item1.name }}
              </div>

              <div class="menu-child-list-lv2" v-if="item1.children && item1.children.length > 0">
                <div @click.stop="goToPage(item2)" class="menu-child-list-lv2-item" v-for="(item2, index2) in item1.children">
                  <div class="menu-child-list-lv3-item-text">
                    {{ item2.name }}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- menu end -->

    <!--loading 动画 begin-->
    <transition name="el-fade-in">
      <loading ref="loading"></loading>
    </transition>
    <!-- loading 动画 end-->
  </div>
</template>

<script>
	export default {
		name: "Header",

    data() {
		  return {
        menu: [
				  { id: 1, name: ['首页', 'HOME'], routerName: 'home' },
				  { id: 2, name: ['公司简介', 'COMPANY'], routerName: 'company' },
				  { id: 3, name: ['业务领域', 'BUSINESS'], routerName: 'business' },
				  { id: 4, name: ['服务目标和内容', 'SERVICE OBJECTIVES'], routerName: 'service-objectives' },
				  { id: 5, name: ['服务网络', 'SERVICE NETWORK'], routerName: 'service-network' },
				  { id: 6, name: ['信息披露', 'INFORMATION'], routerName: 'information' },
				  { id: 7, name: ['热销产品', 'HOT PRODUCT'], routerName: 'hot-product' },
				  { id: 8, name: ['公告发布', 'ANNOUNCEMENT'], routerName: 'announcement' },
				  { id: 9, name: ['联系我们', 'CONTACT US'], routerName: 'contact-us' },
			  ],
      }
    },

    methods: {
      isActive(menuName) {

        // 首页
        if (menuName === 'home' && this.$route.name === 'home') {
          return true
        }

        // 公司简介
        else if (menuName === 'company' && ( this.$route.name === 'introduction' || this.$route.name === 'company' || this.$route.name === 'leaders')) {
          return true
        }

        // 业务领域
        else if (menuName === 'business' && ( this.$route.name === 'aerospace' || this.$route.name === 'responsibility' || this.$route.name === 'market-segments' || this.$route.name ===  'reinsurance-business' || this.$route.name ===  'internet-insurance')) {
          return true
        }

        // 服务目标和内容
        else if (menuName === 'service-objectives' && ( this.$route.name === 'service-objectives' || this.$route.name === 'service-contents')) {
          return true
        }

        // 服务网络
        else if (menuName === 'service-network' && this.$route.name === 'service-network') {
          return true
        }

        // 信息披露
        else if (menuName === 'information' && this.$route.name === 'information') {
          return true
        }

        // 公告发布
        else if (menuName === 'company-dynamic' && (this.$route.name === 'company-dynamic' || this.$route.name === 'company-dynamic-details')) {
          return true
        }

        // 联系我们
        else if (menuName === 'contact-us' && (this.$route.name === 'contact-us')) {
          return true
        }

        return false
      },
  
      // 主菜单跳转
      goToPage(item) {

        if (item.type === 'link' && this.$route.name !== item.routerName) {
          this.$router.push({
            name: item.routerName
          })
        }
      }
    },

    mounted() {


    }
  }
</script>

<style>



</style>
